export default "__VITE_ASSET__o5YF9w9C__"